import { Dispatch, SetStateAction } from 'react';
import { formatMonthYear } from '../../lib/helpers/formatMonthYear/formatMonthYear';
import {
  DECEMBER_OF_PREVIOUS_YEAR,
  JANUARY_OF_PREVIOUS_YEAR,
} from '../../model/consts/months';
import { IRangeDates } from '../../model/types/IRangeDates';
import { IMonthRangePickerWithOptionsProps } from '../../month-range-picker-with-options';
import styles from '../../month-range-picker-with-options.module.scss';

interface IProps {
  setSelectedOption: Dispatch<
    SetStateAction<IMonthRangePickerWithOptionsProps['selectedOption']>
  >;
  setShowOptions: Dispatch<SetStateAction<boolean>>;
  setDates: (dates: IRangeDates) => void;
  selectedOption?: number;
  getOptionsClassnames: (index: number) => string;
}

const MonthRangePickerPrevYearOption = ({
  setSelectedOption,
  setShowOptions,
  setDates,
  getOptionsClassnames,
}: IProps) => {
  const handlePrevYearOptionClick = () => {
    setSelectedOption(1);
    setShowOptions(false);
    setDates({
      start: JANUARY_OF_PREVIOUS_YEAR,
      end: DECEMBER_OF_PREVIOUS_YEAR,
    });
  };

  return (
    <div
      className={getOptionsClassnames(1)}
      onClick={handlePrevYearOptionClick}
    >
      <div className={styles.optionTitle}>За прошлый год</div>
      <div className={styles.optionDesc}>
        {formatMonthYear(JANUARY_OF_PREVIOUS_YEAR)} -{' '}
        {formatMonthYear(DECEMBER_OF_PREVIOUS_YEAR)}
      </div>
    </div>
  );
};

export default MonthRangePickerPrevYearOption;
